import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { getNameInCurrentLanguage } from 'helpers/intl';

import Loader from 'components/layout/Loader';

import FormTextarea from 'components/forms/FormTextarea';

import List from 'components/List';
import Modal from 'components/Modal';

class OrderCancelOrder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cancellationReason: '',
      cancellationText: '',
    };
  }

  componentDidUpdate = prevProps => {
    const { cancellationReasons } = this.props;

    if (prevProps.cancellationReasons.pending && !cancellationReasons.pending) {
      // the list of cancellation reasons is loaded
      // we now have to select te first reason as default
      this.setState({ cancellationReason: cancellationReasons.data.list[0].id });
    }
  };

  updateCancellationReason = e => {
    this.setState({ cancellationReason: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    e.stopPropagation();

    if (this.state.cancellationReason) {
      this.props.onSubmit(this.props.order.id, { ...this.state });
    }
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      show,
      close,
      order,
      formStatus,
      cancellationReasons,
    } = this.props;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.cancel_order}{' '}
            <span class="small hint-text">
              {messages.order} {order.id}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <List
            noRender
            listName="orderCancellationReasons"
            url={'/api/orders/' + order.id + '/cancellationreasons.json'}
            list={cancellationReasons}
          />

          {cancellationReasons.pending ? (
            <Loader />
          ) : (
            <form type="put" onSubmit={this.onSubmit}>
              {cancellationReasons.data.list.map((cancellationReason, i) => {
                return (
                  <div class="radio radio-success" key={i}>
                    <input
                      type="radio"
                      value={cancellationReason.id}
                      name="cancellationReason"
                      id={cancellationReason.id}
                      checked={this.state.cancellationReason === cancellationReason.id}
                      onChange={this.updateCancellationReason}
                    />
                    <label for={cancellationReason.id}>
                      {getNameInCurrentLanguage(cancellationReason.name, appIntl)}
                    </label>
                  </div>
                );
              })}

              <div class="radio radio-success">
                <input
                  type="radio"
                  value="other_reason"
                  name="cancellationReason"
                  id="cancellationReasonOther"
                  checked={this.state.cancellationReason === 'other_reason'}
                  onChange={this.updateCancellationReason}
                />
                <label for="cancellationReasonOther">{messages.other_reason}</label>
              </div>

              <AnimateHeight duration={300} height={this.state.cancellationReason === 'other_reason' ? 'auto' : 0}>
                <div class="form-group-attached">
                  <FormTextarea
                    label={messages.cancellation_reason}
                    value={this.state.cancellationReason}
                    onChange={(name, cancellationText) => this.setState({ cancellationText })}
                    name="cancellationText"
                  />
                </div>
              </AnimateHeight>

              <Button bsStyle="primary" bsSize="lg" block disabled={formStatus.pending} type="submit" class="m-t-20">
                {formStatus.pending ? <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

                {messages.cancel_order}
              </Button>
            </form>
          )}
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    formStatus: state.formStatus.orderActionCancelOrder,
    cancellationReasons: state.list.orderCancellationReasons,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: (orderId, args) => {
      formStatusDispatchHelper(
        'orderActionCancelOrder',
        '/api/orders/' + orderId + '/cancel.json',
        args,
        'put',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(OrderCancelOrder)
  )
);
